import {
  getSessionStorageItem,
  setSessionStorageItem,
} from '../hooks/useSessionStorage';
import {
  CONCIERGE_AUTO_EXPAND_HANDLED,
  CONCIERGE_CHAT_IS_OPEN,
} from './constants';

function hasSessionStorage(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.sessionStorage !== 'undefined'
  );
}

function readSessionFlag(key: string): boolean {
  if (!hasSessionStorage()) {
    return false;
  }

  try {
    return JSON.parse(getSessionStorageItem(key) ?? '') === true;
  } catch {
    return false;
  }
}

/** Returns whether the write landed, so dependent writes can be skipped. */
function writeSessionFlag(key: string, value: boolean): boolean {
  if (!hasSessionStorage()) {
    return false;
  }

  try {
    setSessionStorageItem(key, value);
    return true;
  } catch (e) {
    console.warn(e);
    return false;
  }
}

export function readAIChatOpen(): boolean {
  return readSessionFlag(CONCIERGE_CHAT_IS_OPEN);
}

export function setAIChatOpen(isOpen: boolean) {
  writeSessionFlag(CONCIERGE_CHAT_IS_OPEN, isOpen);
}

/**
 * Whether the auto expand setting has already been acted on in this browser
 * session — either we auto-expanded the panel, or the user closed it.
 */
export function isAutoExpandHandled(): boolean {
  return readSessionFlag(CONCIERGE_AUTO_EXPAND_HANDLED);
}

export function markAutoExpandHandled() {
  writeSessionFlag(CONCIERGE_AUTO_EXPAND_HANDLED, true);
}

export function openAIChat() {
  setAIChatOpen(true);
}

export function closeAIChat() {
  setAIChatOpen(false);
}

export function toggleAIChat() {
  setAIChatOpen(!readAIChatOpen());
}
